import { createSlice } from "@reduxjs/toolkit";

let content = {
  en: {
    en: true,
    navbar: { navbarLinks: ["home", "about", "works", "skills", "contact"] },
    header: {
      greetingIntro: "Hello, I am",
      greetingName: "Murtaza",
      greetingJob: "Web Developer",
    },
    footer: {
      headText: "Take a coffe & chat with me",
      yourName: "Your Name",
      yourEmail: "Your E-mail",
      yourMessage: "Your Message",
      buttonText: { send: "Send Message", sending: "Sending" },
      thankMessage: "Thank you for getting in touch!",
    },
  },
  tr: {
    tr: true,
    navbar: {
      navbarLinks: [
        "anasayfa",
        "hakkimda",
        "projeler",
        "beceriler",
        "iletisim",
      ],
    },
    header: {
      greetingIntro: "Merhaba, ben",
      greetingName: "Murtaza",
      greetingJob: "Web Geliştirici",
    },
    footer: {
      headText: "Bir kahve al & konuşalım",
      yourName: "Adınız",
      yourEmail: "E-Mail Adresiniz",
      yourMessage: "Mesajınız",
      buttonText: { send: "Gönder", sending: "Gönderiliyor" },
      thankMessage: "Mesajın için teşekkürler!",
    },
  },
};

const contentSlice = createSlice({
  name: "content",
  initialState: {
    content: content.en,
    selectedLanguage: "EN",
  },
  reducers: {
    changeLanguage: (state, action) => {
      if (action.payload === "EN") {
        state.content = content.en;
        state.selectedLanguage = "EN";
      } else {
        state.content = content.tr;
        state.selectedLanguage = "TR";
      }
    },
  },
});

export const contentActions = contentSlice.actions;
export default contentSlice.reducer;
